// form_file.tsx
import { useRef, useEffect, useState } from "react";
import InputFormStyle from "../style/input_form.component";
import Icon from "@mdi/react";
import { mdiCamera } from "@mdi/js";
import { InputFormProps } from "./interface/formInterface";
import DivStyle from "../style/div.component";

interface FormFileInputProps extends InputFormProps {
  currentImageUrl?: string;
}

const FormFileInput = (props: FormFileInputProps) => {
  const { value, setValue, label, width, currentImageUrl } = props;
  const fileInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (value === null && fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [value]);
  return (
    <DivStyle width={width} display="flex" flex_direction="column">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <span style={{ color: "white", marginRight: "7px" }}>{label}</span>

        <InputFormStyle
          ref={fileInputRef}
          onChange={(e: any) => {
            setValue(e.target.files[0]);
          }}
          id="input"
          fontSize="14px"
          width="350px"
          type="file"
          accept=".jpg, .jpeg, .png"
        />
      </div>
      {currentImageUrl && (
        <DivStyle marginTop="10px">
          <img
            src={currentImageUrl}
            alt="Current thumbnail"
            style={{ maxWidth: "200px", maxHeight: "200px" }}
          />
        </DivStyle>
      )}
    </DivStyle>
  );
};

export default FormFileInput;
